<template>
  <div class="release-goods main-bg">
    <div class="main-wrap">
      <div class="mt20">
        <business-menu></business-menu>
        <div class="fr release-r">
          <span class="icon-notice">i</span><nav-crumb class="crumb-pt"></nav-crumb>
          <el-form :hide-required-asterisk="true" :model="businessForm" :rules="businessRules" ref="businessForm" label-width="110px" class="business-form">
            <div class="base-info part">
              <p class="title-name">基础信息</p>
              <div class="part-top">
                <el-row>
                  <el-col :span="24">
                    <el-form-item label="商品标题" prop="goodsName">
                      <el-input v-model="businessForm.goodsName" placeholder="请输入标题（5-30个字）" minlength="5" maxlength="30"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="20">
                  <el-col :span="12">
                    <el-form-item label="分类" prop="leiBieTypeName">
                      <el-cascader
                              v-model="businessForm.leiBieTypeName"
                              class="inp-txt"
                              :options="typeList"
                              :props="levelDefault"
                              clearable
                              placeholder="请选择"
                              @change="getTypeId"
                      >
                      </el-cascader>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="库存" prop="stock">
                      <el-input type="number" class="inp-txt" v-model="businessForm.stock" placeholder="请输入库存" ></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="20">
                  <el-col :span="24">
                    <el-form-item label="规格" prop="sizeName">
                      <el-input class="inp-txt" v-model="businessForm.sizeName" placeholder="请输入规格"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </div>
            </div>
            <div class="base-info part mt10">
              <p class="title-name">价格信息</p>
              <div class="part-top">
                <el-row :gutter="20">
                  <el-col :span="12">
                    <el-form-item label="单价" prop="price">
                      <el-input class="inp-txt" :maxlength="6" v-model="businessForm.price" placeholder="请输入单价"></el-input> 元
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="20">
                  <el-col :span="12">
                    <el-form-item label="邮费">
                      <el-input type="number" class="inp-txt" :maxlength="6" v-model="businessForm.distributionFee" placeholder="请输入邮费" @input="changeFee"></el-input> 元
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <div class="goods-radio">
                      <el-radio v-model="isSetPostage" :label="1">包邮</el-radio>
                      <el-radio v-model="isSetPostage" :label="2">邮费到付</el-radio>
                    </div>
                  </el-col>
                </el-row>
              </div>
            </div>
            <div class="photo-info part mt10">
              <p class="title-name">图文描述</p>
              <div class="part-top">
                <el-form-item label="商品描述" prop="goodsDesc" >
                  <el-input
                          type="textarea"
                          placeholder="请描述拍品的细节"
                          v-model="businessForm.goodsDesc"
                          :autosize="{ minRows: 7, maxRows: 25}"
                          resize="none"
                  >
                  </el-input>
                </el-form-item>
                <el-form-item label="封面图片">
                  <upload-file flag="添加上传图片" v-model="businessForm.goodsLog" :limit="1" />
                </el-form-item>
                <!--<el-form-item label="商品轮播图">-->
                  <!--<upload-file flag="添加上传图片" v-model="businessForm.goodsImg" :limit="1" />-->
                <!--</el-form-item>-->
                <el-form-item label="商品详情图">
                  <upload-file flag="添加上传图片" v-model="businessForm.goodsInfoImg" :limit="9" />
                </el-form-item>
                <el-form-item label="商品视频(选填)">
                  <upload-file flag="上传视频" v-model="businessForm.goodsVideo" :limit="1" accept="video/*" />
                </el-form-item>
                <el-form-item>
                  <button type="button" class="btn-apply" @click="submitAddGoods('businessForm')">确认发布</button>
                </el-form-item>
              </div>
            </div>
          </el-form>
        </div>
      </div>


    </div>
  </div>
</template>
<script>
    import BusinessMenu from '../../components/setting/businessMenu'
    import navCrumb from '../../components/crumb/index'
    import Rules from '../../utils/rules'
    import uploadFile from '../../components/uploadFile/index'
    import {getIndexTypeAll,addGoods,editGoods,findGoodsInfoById} from '../../api/goods'
  export default {
      data(){
          return {
              shopInfo:JSON.parse(localStorage.getItem('shop'))||null,
              isSetPostage:1,//是否设置邮费
              businessForm:{
                  goodsName:'',//商品名称
                  goodsLog:'',
                  goodsImg:'',//商品轮播图
                  goodsInfoImg:'',//商品详情图
                  goodsVideo:'',//商品视频
                  sizeName:'',//规格
                  price:'',//单价
                  stock:'',//库存
                  distributionFee:'0',//邮费
                  goodsDesc:'',//商品描述
                  oneTypeId:'',
                  twoTypeId:'',
                  goodsType:1,
                  leiBieTypeName:''
              },
              businessRules:{
                  goodsName: Rules.required('请输入商品名称'),
                  goodsLog: Rules.required('请选择商品图片'),
                  //goodsImg: Rules.required('请选择商品轮播图'),
                  goodsInfoImg: Rules.required('请选择商品详情图'),
                  sizeName: Rules.required('请输入规格'),
                  price: Rules.required('请输入单价'),
                  stock: Rules.required('请输入库存'),
                  goodsDesc: Rules.required('请输入商品描述'),
                  leiBieTypeName: Rules.required('请选择分类')
              },
              levelDefault:{
                  value:'id',
                  label:'typeName',
                  children:'twoTypes'
              },
              typeList:[],
              isReadonly:true
          }
      },
      components:{
          BusinessMenu,
          navCrumb,
          uploadFile
      },
      computed:{
          goodsId(){
              return this.$route.params.goodsId||'';
          }
      },
      created () {
          this.getTypeAll();
      },
      mounted(){
          if(this.goodsId!==''){
              this.getGoodsInfoById();
          }
      },
      methods:{
          changeFee(){
              if(this.businessForm.distributionFee>0){
                  this.isSetPostage=0
              }else{
                  this.isSetPostage=1

              }
          },
          getTypeId(val){
              if(val.length===2){
                  this.businessForm.oneTypeId=val[0];
                  this.businessForm.twoTypeId=val[1];
              }

          },
          getTypeAll(){
              getIndexTypeAll({
                  type:2
              }).then(res=>{
                  this.typeList=res.data;
              })
          },
          getGoodsInfoById(){
              findGoodsInfoById({
                  goodsId:this.goodsId,
                  current:1,
                  size:1
              }).then(res=>{
                  this.businessForm=res.data.goods;
                  this.businessForm.leiBieTypeName=[res.data.oneType.id,res.data.twoType.id];
                  if(this.businessForm.distributionFee==-1){
                      this.businessForm.distributionFee=0
                      this.isSetPostage=2
                  }else if(this.businessForm.distributionFee==0){
                      this.businessForm.distributionFee=0
                      this.isSetPostage=1
                  }else if(this.businessForm.distributionFee>0){
                      this.isSetPostage=0
                  }
              })
          },
          submitAddGoods(formName){
              this.$refs[formName].validate((valid) => {
                  if (valid) {
                      let params = JSON.parse(JSON.stringify(this.businessForm));
                      params.goodsImg=params.goodsInfoImg;
                      if(this.isSetPostage==2){
                          params.distributionFee=-1;
                      }
                      if(this.goodsId==''){
                          addGoods(params).then(res=>{
                              this.$message({
                                  message:res.msg,
                                  type:'success'
                              });
                              this.$router.back();
                          })

                      }else {
                          editGoods(params).then(res=>{
                              this.$message({
                                  message:res.msg,
                                  type:'success'
                              });
                              this.$router.back();
                          })
                      }

                  } else {
                      console.log('error submit!!');
                      return false;
                  }
              });
          }
      },
      watch:{
          'isSetPostage'(val){
              if(val==1||val==2){
                  this.businessForm.distributionFee=0
              }
          },
          'leiBieTypeName'(val){
              this.businessForm.oneTypeId=val[0];
              this.businessForm.twoTypeId=val[1];
          }
      }
  }
</script>

<style lang="scss" scoped>
  @import '../../assets/css/common';
  .crumb-pt{padding:0 0 20px;display: inline-block;line-height:20px;}
  .release-r{
    width:1000px;
    .icon-notice{
      vertical-align: top;
      margin-right: 10px;
      display: inline-block;
      text-align: center;
      line-height: 20px;
      color: #fff;
      width: 20px;
      height: 20px;
      background-color:$main-color;
      -webkit-border-radius: 50%;
      -moz-border-radius: 50%;
      border-radius: 50%;
    }
    .goods-radio{
      width:300px;
      height:40px;
      padding-left:40px;
      line-height:40px;
    }
  }
  .part{
    background-color:#fff;

    .title-name{font-size:14px;color:#222;
      height:54px;
      line-height:54px;
      padding-left:30px;
      font-weight:600;border-bottom:1px dashed #EEEEEE;}
  }
  .part-top{
    padding:20px 80px;
  }
.business-form{
  .inp-txt{width:300px;height:38px;background-color:#FCFCFC;
    display: inline-block;}
}
  .store-map{
    width:626px;
    height:288px;
    background-color:$main-color;
  }
  .upload-certificates{
    display: inline-block;
    &+.upload-certificates{margin-left:50px;}
    border:1px dashed #E4E5E5;
    width:150px;
    height:150px;
    text-align: center;
    color:#999999;
    .upload-plus{padding-top:30px;}
    .btn-plus{font-size:60px;color:#c9c9c9;}

  }
  .btn-apply{
    width:170px;
    height:36px;
    background:$main-color;
    -webkit-border-radius: 3px;
    -moz-border-radius: 3px;
    border-radius: 3px;
    font-size:14px;
    color:#fff;
    margin-top:26px;
  }
</style>
<style lang="scss">
  @import '../../assets/css/common';
  .business-form{
    .el-form-item{
      white-space:nowrap;}
    .el-input__inner{background-color:#FCFCFC;border:1px solid #E4E5E5;}
  }
  .el-radio{margin-right:40px;}
  .el-radio__inner:hover{border:1px solid $main-color;}
  .el-radio__input.is-checked .el-radio__inner{
    border-color: $main-color;
    background: $main-color;}
  .el-radio__input.is-checked+.el-radio__label{color:#333333;}
  .el-textarea__inner{border:1px solid #E4E5E5;background-color:#FCFCFC;
    -webkit-border-radius: 0px;
    -moz-border-radius: 0px;
    border-radius: 0px;}
</style>
